<template>
  <q-dialog v-model="show">
    <q-card style="width: 1000px;" class="bg-krach text-white">
      <q-img :src="start ? '/gif/krach_start.webp' : '/gif/krach_stop.webp'">
        <div class="text-h4 text-weight-bold absolute-top text-center">
          <template v-if="start">
            📉 🎉 Krach en cours ! 🎉 📉
          </template>
          <template v-else>
            Fin du krach
          </template>
        </div>
      </q-img>
    </q-card>
  </q-dialog>
</template>
<script>
export default {
  name: 'krack-dialog',
  props: {
    show: Boolean, 
    start: Boolean,
  }
};
</script>
<style lang="scss">
.bg-krach{
  background: rgb(221,44,0) !important;
  background: linear-gradient(0deg, rgba(221,44,0,1) 0%, rgba(255,112,67,1) 35%, rgba(191,54,12,1) 100%) !important;
}
</style>
